import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Save, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SettingsView = () => {
  const [brand, setBrand] = useState(null);
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { axios.get(`${API}/settings`).then((res) => setBrand(res.data)); }, []);

  const save = async () => {
    setBusy(true); setSaved(false);
    try {
      await axios.put(`${API}/settings`, {
        notify_email: brand.notify_email, hours: brand.hours,
        consent_text_en: brand.consent_text_en, consent_text_es: brand.consent_text_es,
        escalation_minutes: brand.escalation_minutes,
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } finally { setBusy(false); }
  };

  if (!brand) return <div className="empty-state">Loading settings...</div>;

  return (
    <div data-testid="dash-settings">
      <div className="dash-panel">
        <div className="dash-panel__head"><h2>Brand Configuration</h2></div>
        <div className="detail-fields-grid mb-6">
          <div className="detail-field"><span className="detail-field__label">Brand Name</span><span className="detail-field__value">{brand.name}</span></div>
          <div className="detail-field"><span className="detail-field__label">Phone</span><span className="detail-field__value">{brand.phone_display}</span></div>
          <div className="detail-field"><span className="detail-field__label">License</span><span className="detail-field__value">#{brand.license}</span></div>
          <div className="detail-field"><span className="detail-field__label">License</span><span className="detail-field__value">{brand.license}</span></div>
        </div>
        <p style={{ color: 'var(--text-dim)', fontSize: '0.82rem', marginBottom: '1.4rem' }}>Brand name, phone, license, and location are managed in the codebase for the public site (source-controlled). The fields below are live operational settings.</p>

        <div className="form-field">
          <label className="form-label">Alert / Notify Email</label>
          <input className="dash-input" style={{ width: '100%' }} value={brand.notify_email || ''} onChange={(e) => setBrand({ ...brand, notify_email: e.target.value })} data-testid="settings-notify-email" />
        </div>
        <div className="form-field">
          <label className="form-label">Hours</label>
          <input className="dash-input" style={{ width: '100%' }} value={brand.hours || ''} onChange={(e) => setBrand({ ...brand, hours: e.target.value })} data-testid="settings-hours" />
        </div>
        <div className="form-field">
          <label className="form-label">Escalation Threshold (minutes)</label>
          <input type="number" className="dash-input" style={{ width: 160 }} value={brand.escalation_minutes || 15} onChange={(e) => setBrand({ ...brand, escalation_minutes: parseInt(e.target.value, 10) || 15 })} data-testid="settings-escalation" />
        </div>
        <div className="form-field">
          <label className="form-label">Consent Text (English)</label>
          <textarea className="form-textarea" rows={3} style={{ width: '100%' }} value={brand.consent_text_en || ''} onChange={(e) => setBrand({ ...brand, consent_text_en: e.target.value })} data-testid="settings-consent-en" />
        </div>
        <div className="form-field">
          <label className="form-label">Consent Text (Spanish)</label>
          <textarea className="form-textarea" rows={3} style={{ width: '100%' }} value={brand.consent_text_es || ''} onChange={(e) => setBrand({ ...brand, consent_text_es: e.target.value })} data-testid="settings-consent-es" />
        </div>

        <button className="dash-btn primary" onClick={save} disabled={busy} data-testid="settings-save-btn"><Save size={14} /> Save Settings</button>
        {saved && <span style={{ color: 'var(--success)', marginLeft: 12 }}><CheckCircle2 size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />Saved</span>}
      </div>

      <div className="dash-panel">
        <div className="dash-panel__head"><h2>Email Notification Status</h2></div>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
          Live lead-alert emails require a RESEND_API_KEY, which has not been configured yet. All alerts
          are currently logged as <span className="badge badge-muted">pending_api_key</span> rather than
          silently faked as sent. Once the API key is supplied, alerts will begin sending automatically —
          no code changes required.
        </p>
      </div>
    </div>
  );
};

export default SettingsView;
